module.exports = require('./helpers/bundle-url').getBundleURL('d2duB') + "logo-dark.eefe0b7f.svg";